export enum GeneralEmployeeAction {
  REMOVE_EMPLOYEE = 'REMOVE_EMPLOYEE',
}

export enum InviteEmployeeAction {
  SEND_INVITATION = 'SEND_INVITATION',
  RESEND_INVITATION = 'RESEND_INVITATION',
}
